"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importDefault(require("../utils/constants"));
/**
 *
 * Hook to take a component from an initial position
 * and FIX/stick it to the screen. Typically used for
 * nailing down positions of elements and then placing
 * them above other elements in the viewport.
 *
 * Used in:
 * - SidenavItem/Popout
 * - ContextMenu
 *
 * @param $input - a ref to the component we would like to stick
 * @param initialValue - initial positioning CSS values
 */
const useSticky = ({ $el, initialValue, }) => {
    const defaultDisplaySettings = {
        top: (initialValue && initialValue.top) || "0",
        left: (initialValue && initialValue.left) || "100%",
        width: (initialValue && initialValue.width) || "100%",
        position: (initialValue && initialValue.position) || "absolute",
    };
    const [displaySettings, setDisplaySettings] = React.useState(defaultDisplaySettings);
    React.useLayoutEffect(() => {
        const node = $el.current;
        if (node) {
            const rect = node.getBoundingClientRect();
            const needOffset = rect.left + rect.width > window.innerWidth;
            if (needOffset) {
                setDisplaySettings({
                    position: "fixed",
                    left: `${window.innerWidth - rect.width - constants_1.default.space.small}px`,
                    width: `${rect.width}px`,
                    top: `${rect.top}px`,
                });
            }
            else {
                setDisplaySettings({
                    position: "fixed",
                    left: `${rect.left}px`,
                    width: `${rect.width}px`,
                    top: `${rect.top}px`,
                });
            }
        }
    }, [$el]);
    return displaySettings;
};
exports.default = useSticky;
//# sourceMappingURL=useSticky.js.map